import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Img } from 'react-image';

const profileWidth = 325;

const Container = styled.div`
  width: ${profileWidth}px;
  height: 342px;
  display: flex;
  flex-direction: column;
`;

const Photo = styled(Img)`
  width: ${profileWidth}px;
  height: 210px;
  border-radius: 4px;
`;

const ImagePlaceholder = styled.div`
  width: ${profileWidth}px;
  height: 210px;
  border-radius: 4px;
  background-color: ${props => props.theme.secondaryColor};
`;

const Name = styled.span`
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 22px;
  margin-top: 20px;
`;

const Title = styled.span`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 16px;
  line-height: 20px;
`;

export default function Profile(props) {
  const {
    name,
    title,
    titleSecondary,
    photo,
  } = props;

  return (
    <Container>
      {photo
        ? <Photo src={photo} />
        : <ImagePlaceholder />}
      <Name>{name}</Name>
      <Title>{title}</Title>
      {!!titleSecondary && <Title>{titleSecondary}</Title>}
    </Container>
  );
}

Profile.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  titleSecondary: PropTypes.string,
  photo: PropTypes.string,
};

Profile.defaultProps = {
  titleSecondary: null,
  photo: null,
};

export { profileWidth };
